export const base64ToFile = (dataUrl: string, filename: string): File => {
  const [header, data] = dataUrl.split(",");
  const mimeType = header.match(/:(.*?);/)?.[1] ?? "image/png";
  const isBase64 = header.includes(";base64");
  if (isBase64) {
    const byteString = atob(data);
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }
    return new File([byteArray], filename, { type: mimeType });
  }

  const decoded = decodeURIComponent(data);
  return new File([decoded], filename, { type: mimeType });
};
